import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, message, Space } from 'antd';
import { getCustomerCouriers, updateCustomerCouriers } from '../../services/userService';

const CustomerCourierModal = ({ visible, customerId, onClose }) => {
  const [couriers, setCouriers] = useState([]);
  const [selectedCouriers, setSelectedCouriers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && customerId) {
      fetchCouriers();
    }
  }, [visible, customerId]);

  const fetchCouriers = async (retry = true) => {
    try {
      setLoading(true);
      const data = await getCustomerCouriers(customerId);
      setCouriers(data.couriers);
      setSelectedCouriers(data.couriers.filter(c => c.is_available).map(c => c.id));
    } catch (error) {
      if (error.response?.status === 401 && retry) {
        return fetchCouriers(false);
      }
      message.error('获取快递公司列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async (retry = true) => {
    try {
      setLoading(true);
      await updateCustomerCouriers(customerId, selectedCouriers);
      message.success('快递公司权限更新成功');
      onClose();
    } catch (error) {
      if (error.response?.status === 401 && retry) {
        return handleOk(false);
      }
      message.error('更新失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleChange = (courierId) => {
    setSelectedCouriers(prev => {
      if (prev.includes(courierId)) {
        return prev.filter(id => id !== courierId);
      } else {
        return [...prev, courierId];
      }
    });
  };

  return (
    <Modal
      title="指定可用快递公司"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {couriers.map(courier => (
          <div key={courier.id} style={{ marginBottom: '12px' }}>
            <Checkbox
              checked={selectedCouriers.includes(courier.id)}
              onChange={() => handleChange(courier.id)}
            >
              {courier.name}
            </Checkbox>
            {courier.logo && (
              <img 
                src={courier.logo} 
                alt={courier.name} 
                style={{ 
                  height: '20px', 
                  marginLeft: '8px',
                  verticalAlign: 'middle'
                }} 
              />
            )}
          </div>
        ))}
        {couriers.length === 0 && (
          <div style={{ color: '#999', textAlign: 'center' }}>
            暂无可用快递公司
          </div>
        )}
      </Space>
    </Modal>
  );
};

export default CustomerCourierModal;
